<template>
  <div class="resume-check-total-container absolute">
    <div class="resume-check-content w-full flex justify-between items-center">
      <template v-if="result">
        <div v-if="result.total_score || result.brief_comment" class="flex flex-col flex-1">
          <div class="score-container flex items-center w-full">
            <div class="score-number flex-shrink-0">
              <span>{{ result.total_score }}</span>
              <span class="score-unit">分</span>
            </div>
            <el-tooltip :content="result.brief_comment" placement="top">
              <div class="check-result-desc font-medium">
                {{ result.brief_comment }}
              </div>
            </el-tooltip>
          </div>
          <div class="progress-container w-full">
            <div class="progress-bar" :style="result.total_score ? { width: `${result.total_score}%` } : { width: '0%' }"></div>
          </div>
        </div>
        <div v-else>一键诊断简历问题，提升投递通过率</div>
        <button @click="clickCheckResume" class="check-resume-btn flex justify-center items-center flex-shrink-0 font-medium">
          <img
            v-if="checkLoading"
            class="check-loading-icon"
            src="https://logo.wondercv.com/banners/t09ku6pD9UQ7Ivg.png"
            alt=""
          />
          {{ checkLoading ? '检查中' : '智能检查' }}
        </button>
      </template>
    </div>
    <div class="resume-suggestion-total cursor-pointer">
      <template v-if="checkLoading">
        <el-carousel height="21px" direction="vertical" autoplay indicator-position="none" :interval="3000">
          <el-carousel-item v-for="(item, index) in CHECK_LOADING_TEXTS" :key="index">
            <span class="checking-text">{{ item }}</span>
          </el-carousel-item>
        </el-carousel>
      </template>
      <template v-else>
        <tamplate v-if="suggestions && suggestions.total_issue">
          当前简历有 <span class="highlight-text">{{ suggestions.total_issue }}项</span> 待修改问题
        </tamplate>
        <template v-else>
          存在 <span class="highlight-text">3项</span> 问题影响投递通过率，优化后预计提升 <span class="highlight-text">25%</span>
        </template>
        <div v-if="suggestions && suggestions.list && suggestions.list.length" class="total-detail-issue flex flex-wrap">
          <template v-for="(item, index) in suggestions.list">
            <div v-if="item.count" :key="index" class="issue-item flex items-center" @click="clickIssueItem(item)">
              <img v-if="item.icon" :src="item.icon" alt="" />
              <span class="title">{{ item.title }}</span>
              <span class="count flex items-center">{{ item.count }}项</span>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
const CHECK_LOADING_TEXTS = [
  '正在获取简历数据',
  '正在分析简历原文',
  '正在获取优化建议',
  '正在对简历综合评分',
]
export default {
  name: 'ResumeCheckTotal',
  props: {
    checkResult: {
      type: Object,
      default: null,
    },
    checkLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CHECK_LOADING_TEXTS,
    };
  },
  computed: {
    result() {
      return this.checkResult?.smart_check_result;
    },
    suggestions() {
      return this.checkResult?.suggestions;
    },
  },
  methods: {
    clickCheckResume() {
      this.$emit('clickCheckResume');
    },
    clickIssueItem(item) {
      this.$emit('clickIssueItem', item);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.resume-check-total-container {
  top: 0;
  width: calc(100% - 48px);
  background: linear-gradient(45deg, $check-total-bg-start 0%, $check-total-bg-middle 62%, $check-total-bg-end 100%);
  margin-bottom: 32px;
  border-radius: 12px;
  border: 1px solid $check-total-border-color;
  box-sizing: border-box;
  z-index: 99;
  .resume-check-content {
    justify-content: space-between;
    height: 72px;
    background: linear-gradient(270deg, #febf5d 0%, #e15d3f 100%);
    border-radius: 12px;
    padding: 0 24px;
    color: #fff;
    .score-number {
      font-size: 28px;
      font-weight: bold;
      margin-right: 30px;
      .score-unit {
        margin-left: 4px;
        font-size: 12px;
      }
    }
    .check-result-desc {
      font-size: 14px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 249px;
      font-weight: 500;
    }
    .progress-container {
      height: 4px;
      background-color: rgba($color: #fff, $alpha: 0.3);
      border-radius: 4px;
      .progress-bar {
        height: 100%;
        background-color: #fff;
        border-radius: 4px;
        transition: width 0.3s ease-in-out;
      }
    }
    .check-resume-btn {
      width: 104px;
      height: 32px;
      border-radius: 16px;
      background-color: #fff;
      color: $theme-color;
      font-size: 14px;
      margin-left: 54px;
      font-weight: 500;
      .check-loading-icon {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
  }
  .resume-suggestion-total {
    padding: 16px 24px;
    color: $text-color;
    .checking-text {
      font-size: 14px;
      font-weight: 500;
    }
    .highlight-text {
      color: $theme-color;
    }
    .total-detail-issue {
      display: none;
      padding: 16px;
      background-color: $resume-check-total-bg-color;
      border-radius: 8px;
      margin-top: 14px;
      row-gap: 10px;
      .issue-item {
        width: 50%;
        img {
          width: 28px;
          height: 28px;
          margin-right: 4px;
        }
        .title {
          color: $text-color;
          font-weight: 500;
          margin-right: 16px;
        }
        .count {
          height: 20px;
          background-color: rgba($color: #ff6644, $alpha: 0.12);
          color: $theme-color;
          padding: 0 8px;
          font-size: 12px;
          border-radius: 10px;
        }
      }
    }
    &:hover {
      .total-detail-issue {
        display: flex;
      }
    }
  }
}
</style>
